import { ActionTypes } from "@/App/constants/actionTypes";
import { PlanAccountTypes } from "@/types";

type GetPlanAccountAction = {
  type: typeof ActionTypes.GET_PLAN_ACCOUNT;
  payload: string;
};

export const getPlanAccount = (data: string): GetPlanAccountAction => {
  return {
    type: ActionTypes.GET_PLAN_ACCOUNT,
    payload: data,
  };
};

type GetPlanAccountResults = {
  type: typeof ActionTypes.GET_PLAN_ACCOUNT_RESULTS;
  payload: PlanAccountTypes.PlanAccountInformation;
};

export const getPlanAccountResults = (data: PlanAccountTypes.PlanAccountInformation): GetPlanAccountResults => {
  return {
    type: ActionTypes.GET_PLAN_ACCOUNT_RESULTS,
    payload: data,
  };
};

export type GetPlanAccountActions = GetPlanAccountAction | GetPlanAccountResults;
